// import SectionLabel from '@common/SectionLabel'
import {  WHY_CHOOSE_SERVICES,ROUTES } from '@/constants'
import { Link, useNavigate } from 'react-router-dom'
import Button from '@ui/Button'

export function WhyChooseServices() {
  const navigate = useNavigate()  
  return (
    <section id="why-choose-services" className="section-py wcs-section" aria-labelledby="wcs-heading">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <span class="process-eyebrow">AI INTEGRATED SERVICES</span>
          <h2 id="wcs-heading">Delivering Technology. Enabling Businesses.</h2>
          <p className="section-subheading">Your business deserves technology solutions built around your needs — not generic packages. We provide customized, scalable, AI enabled IT services that evolve with your business, ensuring the right fit for your people and processes.</p>
        </div>
        <div className="wcs-grid">
          {WHY_CHOOSE_SERVICES.map((item, i) => (
            <div
  key={item.title}
  className="wcs-card"
  data-aos="fade-up"
  data-aos-delay={i * 70}
  role="button"
  tabIndex={0}
  aria-label={`Learn more about ${item.title}`}
   onClick={() => navigate(item.link)}
  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') navigate(item.link) }}
  onMouseMove={(e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty("--x", `${x}px`);
    card.style.setProperty("--y", `${y}px`);
    const rotateY = ((x / rect.width) - 0.5) * 8;
    const rotateX = ((rect.height / 2 - y) / rect.height) * 8;
    card.style.transform = `
      perspective(900px)
      rotateX(${rotateX}deg)
      rotateY(${rotateY}deg)
      translateY(-8px)
    `;
  }}
  onMouseLeave={(e) => {
    const card = e.currentTarget;
    card.style.transition = "transform .45s cubic-bezier(.22,.61,.36,1)";
    card.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg) translateY(0)";
  }}
>
              <div className="wcs-icon" aria-hidden="true">
                {/* <i className={`fa-solid ${item.icon}`} /> */}
                {/* <img src={item.icon} /> */}

                 <span src={item.icon} alt="" className="item-icon"  
                 style={{ WebkitMask: `url(${item.icon}) center / contain no-repeat`,
                          mask: `url(${item.icon}) center / contain no-repeat`, }} >
                 </span>
              </div>
              <h3 className="wcs-title">{item.title}</h3>
              <p className="wcs-desc">{item.desc}</p>
               <Link to={item.link} >
              <div className="wcs-arrow">
                <i className="fa-solid fa-arrow-right"></i>
              </div>
              </Link>
              
            </div>
          ))}
        </div>
      </div>
      <div className="wcs-actions">
            <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up">
              Book A Free Consultation
            </Button>                      
      </div>
    </section>
  )
}
